import * as React from 'react';
import Constants from 'src/support/Constants';
// import System from "../../../helper/system";
import QuoteCartShippingDetail from './QuoteCartShippingDetail';
// const c = System.getParams();

// Note - might be need to add other detail in right Content.
const QuoteCartRightContent = (props) => {
    return (
        <>
            <div className="col-xl-3 mb-4 cart-right-wrapper">
                <QuoteCartShippingDetail summaryFor={Constants.systemModules.CART}/>
            </div>
        </>
    );
}

export default QuoteCartRightContent;